/* eslint-disable */
/**
 * Bundle Campaign Popup
 * ---------------------
 * Fires after 5 seconds of scrolling on the homepage and other browse pages.
 * Promotes the $554 accessory bundle that ships free with a coloured
 * XE Pro S or any Altis Sigma MX (JP 2026-10-02 — XF Pro / Delta removed).
 * Dismissed once per session via sessionStorage.
 *
 * Suppressed on:
 *   - /cart, /checkout (do not disrupt purchase)
 *   - /pages/gear-shop (already promoting accessories prominently)
 *   - XE Pro S / Sigma MX PDPs (already have inline bundle banner)
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'bundle_popup_dismissed_v2'; // v2: offer changed 2026-10-02 — re-show once
  var SCROLL_DWELL_MS = 5000;

  var path = window.location.pathname.replace(/\/$/, '');
  var SUPPRESS_PATHS = [/^\/cart/, /^\/checkout/, /^\/pages\/gear-shop/];
  var SUPPRESS_PRODUCT_HANDLES = ['xe-pro-s', 'sigma-mx'];

  // Suppression checks
  for (var i = 0; i < SUPPRESS_PATHS.length; i++) {
    if (SUPPRESS_PATHS[i].test(path)) return;
  }
  for (var j = 0; j < SUPPRESS_PRODUCT_HANDLES.length; j++) {
    if (path === '/products/' + SUPPRESS_PRODUCT_HANDLES[j]) return;
  }
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
  } catch (e) { /* sessionStorage might be unavailable in private mode — proceed */ }

  var scrollStarted = false;
  var scrollStartTime = 0;
  var fired = false;
  var checkTimer = null;

  function onScroll() {
    if (scrollStarted) return;
    if (window.scrollY > 100) {
      scrollStarted = true;
      scrollStartTime = Date.now();
      checkTimer = setTimeout(maybeShow, SCROLL_DWELL_MS);
    }
  }

  function maybeShow() {
    if (fired) return;
    fired = true;
    showPopup();
  }

  function dismiss() {
    var el = document.getElementById('bundle-popup-root');
    if (el) el.remove();
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    document.removeEventListener('keydown', onKeydown);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') dismiss();
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'style') node.style.cssText = attrs[k];
      else if (k === 'text') node.textContent = attrs[k];
      else if (k === 'on') Object.keys(attrs.on).forEach(function (ev) { node.addEventListener(ev, attrs.on[ev]); });
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function showPopup() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fadeIn = reduced ? '' : 'opacity:0;animation:bp-fade-in 220ms ease forwards;';
    var slideIn = reduced ? '' : 'transform:translateY(20px);animation:bp-slide-in 280ms cubic-bezier(0.2,0.9,0.3,1) forwards;';

    var style = document.createElement('style');
    style.id = 'bundle-popup-style';
    style.textContent = [
      '@keyframes bp-fade-in { to { opacity: 1; } }',
      '@keyframes bp-slide-in { to { transform: translateY(0); opacity: 1; } }',
      '#bundle-popup-root, #bundle-popup-root * { box-sizing: border-box; }',
      '#bundle-popup-card { max-height: calc(100dvh - 32px); max-height: calc(100vh - 32px); overflow-y: auto; -webkit-overflow-scrolling: touch; }',
      '#bundle-popup-card a { transition: transform 150ms ease; }',
      '#bundle-popup-card a:hover { transform: translateY(-2px); }',
      '#bundle-popup-card a:focus-visible, #bundle-popup-card button:focus-visible { outline: 2px solid #15171B; outline-offset: 3px; }',
      '#bundle-popup-card .bp-free { display:inline-block; background:#D6FF00; padding:0 0.14em; border-radius:0.12em; }',
      '@media (prefers-reduced-motion: reduce) {',
      '  #bundle-popup-card a, #bundle-popup-card a:hover { transition: none; transform: none; }',
      '}',
      '@media (max-width: 600px) {',
      '  #bundle-popup-root { padding: 12px !important; }',
      '  #bundle-popup-card { padding: 28px 20px 24px !important; border-radius: 24px !important; max-width: 100% !important; }',
      '  #bundle-popup-card h2 { font-size: 1.6rem !important; line-height: 1 !important; }',
      '  #bundle-popup-card p { font-size: 0.95rem !important; }',
      '  #bundle-popup-ctas { flex-direction: column !important; gap: 8px !important; }',
      '  #bundle-popup-ctas a { width: 100% !important; padding: 13px 18px !important; }',
      '}',
      '@media (max-width: 360px) {',
      '  #bundle-popup-card { padding: 24px 16px 20px !important; }',
      '  #bundle-popup-card h2 { font-size: 1.4rem !important; }',
      '  #bundle-popup-card p { font-size: 0.9rem !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);

    var overlay = el('div', {
      id: 'bundle-popup-root',
      role: 'dialog',
      'aria-modal': 'true',
      'aria-labelledby': 'bundle-popup-headline',
      style: 'position:fixed;inset:0;z-index:99998;background:rgba(21,23,27,0.55);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;padding:20px;' + fadeIn,
      on: { click: function (e) { if (e.target === overlay) dismiss(); } }
    });

    var card = el('div', {
      id: 'bundle-popup-card',
      style: 'position:relative;max-width:580px;width:100%;background:#FFFFFF;color:#15171B;border-radius:32px;padding:40px 40px 32px;text-align:center;box-shadow:0 30px 80px rgba(21,23,27,0.28);font-family:Poppins,sans-serif;' + slideIn
    });

    var closeBtn = el('button', {
      type: 'button',
      'aria-label': 'Close',
      style: 'position:absolute;top:14px;right:14px;width:44px;height:44px;background:#F4F5F7;color:#15171B;border:none;border-radius:50%;font-size:1.4rem;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;font-family:Poppins,sans-serif;',
      text: '×',
      on: { click: dismiss }
    });

    var eyebrow = el('p', {
      style: 'display:inline-block;margin:0 0 16px;padding:6px 12px;border-radius:999px;background:#D9104A;color:#FFFFFF;font-size:0.78rem;letter-spacing:0.08em;text-transform:uppercase;font-weight:700;',
      text: 'On now · While stock lasts'
    });

    var headline = el('h2', {
      id: 'bundle-popup-headline',
      style: 'margin:0 0 14px;font-family:var(--gb-display, Archivo, sans-serif);font-stretch:125%;font-size:clamp(1.7rem,4.4vw,2.6rem);font-weight:900;line-height:1;letter-spacing:-0.015em;text-transform:uppercase;color:#15171B;overflow-wrap:break-word;'
    });
    headline.appendChild(el('span', { 'class': 'bp-free', text: 'Free' }));
    headline.appendChild(document.createTextNode(' $554 accessory kit'));

    var body = el('p', {
      style: 'margin:0 0 24px;font-size:1.02rem;line-height:1.6;max-width:470px;margin-left:auto;margin-right:auto;color:#4B515C;font-weight:400;'
    });
    body.appendChild(document.createTextNode('The entire 8-piece accessory kit lands free in your cart with a coloured '));
    var s1 = el('strong', { style: 'font-weight:700;color:#15171B;', text: 'XE Pro S' });
    body.appendChild(s1);
    body.appendChild(document.createTextNode(' (Green, Pink, White, Grey) or an '));
    var s2 = el('strong', { style: 'font-weight:700;color:#15171B;', text: 'Altis Sigma MX' });
    body.appendChild(s2);
    body.appendChild(document.createTextNode(' in any colour.'));

    var ctaRow = el('div', {
      id: 'bundle-popup-ctas',
      style: 'display:flex;gap:10px;justify-content:center;flex-wrap:wrap;'
    });
    var primary = el('a', {
      href: '/products/xe-pro-s',
      style: 'display:inline-flex;align-items:center;justify-content:center;padding:0 22px;min-height:52px;background:#D6FF00;color:#15171B;border:none;font-family:Poppins,sans-serif;font-weight:700;font-size:0.95rem;text-decoration:none;border-radius:999px;',
      text: 'Shop coloured XE Pro S'
    });
    var secondary = el('a', {
      href: '/products/sigma-mx',
      style: 'display:inline-flex;align-items:center;justify-content:center;padding:0 22px;min-height:52px;background:#15171B;color:#FFFFFF;border:none;font-family:Poppins,sans-serif;font-weight:700;font-size:0.95rem;text-decoration:none;border-radius:999px;',
      text: 'Shop Altis Sigma MX'
    });
    ctaRow.appendChild(primary);
    ctaRow.appendChild(secondary);

    var fineprint = el('p', {
      style: 'margin:18px 0 0;font-size:0.8rem;color:#4B515C;font-weight:500;line-height:1.5;',
      text: 'XE Pro S: coloured variants only (Black doesn’t qualify). Altis Sigma MX: any colour · One kit per order'
    });

    card.appendChild(closeBtn);
    card.appendChild(eyebrow);
    card.appendChild(headline);
    card.appendChild(body);
    card.appendChild(ctaRow);
    card.appendChild(fineprint);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    document.addEventListener('keydown', onKeydown);

    // Focus the close button so keyboard users can dismiss immediately
    try { closeBtn.focus(); } catch (e) {}
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
